
import Button from '@/components/detail/Button.vue'
export default {
  components: { Button },
  props: {
    result: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    d() {
      // 数据
      console.log(this.result, 77789)
      if (this.result.type == 1) {
        return {
          icon: 'https://resources1.interface003.com/web20/img/service/tzz1.svg',
          h: this.$v('成功领取“投资者”身份'),
          p: this.$v('我们为您提供外汇交易商信息、用户评价和风险警示，帮助您做出明智的投资决策，选择可靠的外汇交易商，并增强对外汇市场的认识和风险意识。')
        }
      } else {
        return {
          icon: 'https://resources1.interface003.com/web20/img/service/kol1.svg',
          h: this.$v('成功领取“KOL”身份'),
          p: this.$v('我们为您提供专业的外汇行业社区氛围，请积极参与社区贡献，通过高质量的内容创作活跃社区氛围，升级KOL身份、获取流量及权益加持。')
        }
      }
    }
  },
  methods: {
    tohome() {
      window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/`)
    }
  }
}
